module.exports = __webpack_public_path__ + "static/media/lw.f3018343.png";